import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  overflow: auto;
`

export const TitleContainer = styled.div`
  position: relative;
  margin-bottom: 32px;
`

export const ButtonsContainer = styled.div`
  position: absolute;
  display: flex;
  gap: 24px;
`
